import { useCallback, useEffect, useState } from 'react'
import request from 'services/request'
import usePrevious from 'hooks/usePrevious'

export interface GamesList {
  id: string
  gameAlias: string
  title: string
  startTime: string
  cover: string
  tags: string | null
  publishTime: string
  publisher: string
  introduction: string | null
  description: string
  linkUrl: string
  relatedArticleList: string | null
  appointmentStatus: string | null
}

export function useOurGames(): { loading: boolean; games: GamesList[] } {
  const [loading, setLoading] = useState(true)
  const [games, setGames] = useState<GamesList[]>([])
  const previousGames = usePrevious(games)
  useEffect(() => {
    if (!previousGames) {
      request
        .get('gamezone/v1/games')
        .then((result: any) => {
          if (result?.success) {
            setLoading(false)
            setGames(result.data || [])
          }
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [previousGames])
  return { loading, games }
}

export interface relatedArticle {
  cover: string
  description: string
  id: string
  info: string
  linkUrl: string
  title: string
  createTime: string
  tags: {
    tagId: string
    tagName: string
  }[]
}

export interface GameInfo {
  appendixs: {
    sortCode: number
    type: number
    url: string
  }[]
  firstBkColor: string
  secondBkColor: string
  logoIcon: string
  updates: string | null
  detailed: string | null
  appointmentStatus: number
  description: string
  id: string
  gameAlias: string | null
  introduction: string
  exclusiveId: string
  exclusiveName: string
  linkUrl: string
  publishTime: string
  publisher: string
  recommendUrl: string | null
  recommendPic: string | null
  relatedArticleList: relatedArticle[]
  startTime: string
  cover: {
    sortCode: number
    type: number
    url: string
  }
  tags: [
    {
      tagId: string
      tagName: string
    }
  ]
  title: string
}

export function useGameInfo(
  gameAlias: string | undefined,
  type?: string,
  data?: GameInfo
): {
  loading: boolean
  info: GameInfo | any | undefined
  doFetch: () => void
} {
  const [loading, setLoading] = useState(true)
  const [info, setInfo] = useState<GameInfo | any | undefined>()

  const fetchInfo = useCallback(
    (falg: string | undefined) => {
      if (falg === 'inGame') {
        setInfo(data)
      } else {
        if (gameAlias !== undefined && gameAlias !== '') {
          request
            .get(`gamezone/v1/game/info/${gameAlias}`)
            .then((result: any) => {
              setLoading(false)
              if (result?.success) {
                setInfo(result.data)
              }
            })
            .catch(() => {
              setLoading(false)
            })
        }
      }
    },
    [gameAlias, data]
  )

  useEffect(() => {
    fetchInfo(type)
  }, [fetchInfo, type])

  const doFetch = useCallback(() => {
    fetchInfo('doFetch')
  }, [fetchInfo])

  return { loading, info, doFetch }
}

export async function appointment(gameAlias: string) {
  return await request.get(`gamezone/v1/appointment/${gameAlias}`)
}
export async function eventCancellation(gameAlias: string) {
  return await request.post(`gamezone/activity/v1/eventCancellation`, {
    gameAlias,
  })
}
